const MONTH_NAMES = ['Led','Úno','Bře','Dub','Kvě','Čvn','Čvc','Srp','Zář','Říj','Lis','Pro']
const MONTHS = Array.from({ length: 12 }, (_, i) => i + 1)
const DAYS   = Array.from({ length: 31 }, (_, i) => i + 1)

function daysInMonth(year, month) {
  return new Date(year, month, 0).getDate()
}

const cb = 'border-b border-r border-gray-200 group-last:border-b-0 px-1 py-0.5'

// left/right: { dataMap, getCellStyle, formatCell, title }
// orientation: 'normal' (řádky = dny, 2× sloupce měsíce) | 'transposed' (řádky = měsíce, 2× sloupce dny)
export function DualGrid({ year, left, right, orientation = 'normal' }) {
  const fmtL = left.formatCell  ?? (v => v.toFixed(1))
  const fmtR = right.formatCell ?? (v => v.toFixed(1))

  if (orientation === 'transposed') {
    return (
      <div className="h-full overflow-hidden border border-gray-200">
        <div className="h-full overflow-auto">
          <table className="border-separate border-spacing-0 border-l-2 border-l-gray-400 border-r-2 border-r-gray-400 border-b-2 border-b-gray-400 text-xs">
            <thead>
              <tr>
                <th rowSpan={2} className="sticky left-0 top-0 z-30 bg-gray-50 border-t-2 border-t-gray-400 border-b border-b-gray-400 border-r border-r-gray-400 px-2 py-1 font-normal text-center text-gray-500 min-w-[2.5rem]">Měsíc</th>
                <th colSpan={31} className="sticky top-0 z-20 h-8 bg-gray-50 border-t-2 border-t-gray-400 border-b border-r border-gray-200 px-2 text-gray-600 font-medium text-center">{left.title}</th>
                <th colSpan={31} className="sticky top-0 z-20 h-8 bg-gray-50 border-t-2 border-t-gray-400 border-b border-r border-gray-200 border-l border-l-gray-400 px-2 text-gray-600 font-medium text-center">{right.title}</th>
              </tr>
              <tr>
                {DAYS.map(d => (
                  <th key={`lh-${d}`} className="sticky top-8 z-20 bg-gray-50 border-b border-b-gray-400 border-r border-r-gray-200 px-1 py-1 text-gray-500 font-normal text-center min-w-[2.2rem]">{d}.</th>
                ))}
                {DAYS.map((d, i) => (
                  <th key={`rh-${d}`} className={`sticky top-8 z-20 bg-gray-50 border-b border-b-gray-400 border-r border-r-gray-200 px-1 py-1 text-gray-500 font-normal text-center min-w-[2.2rem]${i === 0 ? ' border-l border-l-gray-400' : ''}`}>{d}.</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {MONTHS.map(month => {
                const maxDay = daysInMonth(year, month)
                const dayCell = (side, fmt, isRight) =>
                  DAYS.map((day, i) => {
                    const sep = isRight && i === 0 ? ' border-l border-l-gray-400' : ''
                    if (day > maxDay) return <td key={`${isRight ? 'r' : 'l'}-${day}`} className={`${cb} bg-gray-100${sep}`} />
                    const k = `${String(month).padStart(2,'0')}-${String(day).padStart(2,'0')}`
                    const value = side.dataMap.get(k) ?? null
                    const style = side.getCellStyle ? side.getCellStyle(value) : null
                    return (
                      <td
                        key={`${isRight ? 'r' : 'l'}-${day}`}
                        style={style ? { backgroundColor: style.bg, color: style.text } : undefined}
                        className={`${cb} text-right tabular-nums whitespace-nowrap${!style ? ' text-gray-300' : ''}${sep}`}
                      >
                        {value != null ? fmt(value) : '—'}
                      </td>
                    )
                  })
                return (
                  <tr key={month} className="group">
                    <td className="sticky left-0 z-10 bg-gray-50 border-b border-b-gray-200 border-r border-r-gray-400 group-last:border-b-0 px-2 py-0.5 text-gray-500 text-center whitespace-nowrap">
                      {MONTH_NAMES[month - 1]}
                    </td>
                    {dayCell(left, fmtL, false)}
                    {dayCell(right, fmtR, true)}
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  return (
    <div className="h-full overflow-hidden border border-gray-200">
      <div className="h-full overflow-auto">
        <table className="border-separate border-spacing-0 border-l-2 border-l-gray-400 border-r-2 border-r-gray-400 border-b-2 border-b-gray-400 text-xs">
          <thead>
            <tr>
              <th
                rowSpan={2}
                className="sticky left-0 top-0 z-30 bg-gray-50 border-t-2 border-t-gray-400 border-b border-b-gray-400 border-r border-r-gray-400 px-2 py-1 font-normal text-center text-gray-500 min-w-[2rem]"
              >Den</th>
              <th
                colSpan={12}
                className="sticky top-0 z-20 h-8 bg-gray-50 border-t-2 border-t-gray-400 border-b border-r border-gray-200 px-2 text-gray-600 font-medium text-center"
              >
                {left.title}
              </th>
              <th
                colSpan={12}
                className="sticky top-0 z-20 h-8 bg-gray-50 border-t-2 border-t-gray-400 border-b border-r border-gray-200 border-l border-l-gray-400 px-2 text-gray-600 font-medium text-center"
              >
                {right.title}
              </th>
            </tr>
            <tr>
              {MONTHS.map(m => (
                <th
                  key={`l-${m}`}
                  className="sticky top-8 z-20 bg-gray-50 border-b border-b-gray-400 border-r border-r-gray-200 px-1 py-1 text-gray-500 font-normal text-center min-w-[3.2rem]"
                >
                  {MONTH_NAMES[m - 1]}
                </th>
              ))}
              {MONTHS.map((m, i) => (
                <th
                  key={`r-${m}`}
                  className={`sticky top-8 z-20 bg-gray-50 border-b border-b-gray-400 border-r border-r-gray-200 px-1 py-1 text-gray-500 font-normal text-center min-w-[3.2rem]${i === 0 ? ' border-l border-l-gray-400' : ''}`}
                >
                  {MONTH_NAMES[m - 1]}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {DAYS.map(day => (
              <tr key={day} className="group">
                <td className="sticky left-0 z-10 bg-gray-50 border-b border-b-gray-200 border-r border-r-gray-400 group-last:border-b-0 px-2 py-0.5 text-gray-500 text-center whitespace-nowrap">
                  {day}.
                </td>
                {MONTHS.map(month => {
                  const maxDay = daysInMonth(year, month)
                  if (day > maxDay) {
                    return <td key={`l-${month}`} className="border-b border-r border-gray-200 group-last:border-b-0 px-1 py-0.5 bg-gray-100" />
                  }
                  const k = `${String(month).padStart(2,'0')}-${String(day).padStart(2,'0')}`
                  const value = left.dataMap.get(k) ?? null
                  const style = left.getCellStyle ? left.getCellStyle(value) : null
                  return (
                    <td
                      key={`l-${month}`}
                      style={style ? { backgroundColor: style.bg, color: style.text } : undefined}
                      className={`border-b border-r border-gray-200 group-last:border-b-0 px-1 py-0.5 text-right tabular-nums whitespace-nowrap${!style ? ' text-gray-300' : ''}`}
                    >
                      {value != null ? fmtL(value) : '—'}
                    </td>
                  )
                })}
                {MONTHS.map((month, i) => {
                  const maxDay = daysInMonth(year, month)
                  const sepClass = i === 0 ? ' border-l border-l-gray-400' : ''
                  if (day > maxDay) {
                    return <td key={`r-${month}`} className={`border-b border-r border-gray-200 group-last:border-b-0 px-1 py-0.5 bg-gray-100${sepClass}`} />
                  }
                  const k = `${String(month).padStart(2,'0')}-${String(day).padStart(2,'0')}`
                  const value = right.dataMap.get(k) ?? null
                  const style = right.getCellStyle ? right.getCellStyle(value) : null
                  return (
                    <td
                      key={`r-${month}`}
                      style={style ? { backgroundColor: style.bg, color: style.text } : undefined}
                      className={`border-b border-r border-gray-200 group-last:border-b-0 px-1 py-0.5 text-right tabular-nums whitespace-nowrap${!style ? ' text-gray-300' : ''}${sepClass}`}
                    >
                      {value != null ? fmtR(value) : '—'}
                    </td>
                  )
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
